import IconMembershipFloatingCta from '@/assets/icons/Membership/IconMembershipFloatingCta.svg?react';
import { useAppSelector } from '@/redux/store';
import useWebview from '@/hooks/V3/useWebview';
import { useSearchParams } from 'react-router-dom';
import { PC_HERO_BADGE_FIRST_PAYMENT_TYPE } from '@/pages/mobile-membership/mobile-membership-utils';
import { useMobileMembershipPolicy } from '@/pages/mobile-membership/use-mobile-membership-policy';

import {
  buildMembershipPreviewFloatingUrl,
  getMembershipPreviewFloatingCtaCopy,
  MEMBERSHIP_PREVIEW_FLOATING_NOTICE,
} from './membership-preview-floating-cta';

type MembershipPreviewFloatingCTAProps = {
  showPreviewNotice?: boolean;
};

const MembershipPreviewFloatingCTA = ({
  showPreviewNotice = true,
}: MembershipPreviewFloatingCTAProps) => {
  const { CplatToken } = useAppSelector((state) => state.user);
  const [searchParams] = useSearchParams();
  const { postMessage } = useWebview();
  const { policy } = useMobileMembershipPolicy();
  const isFirstPaymentUser =
    policy.pcHeroBadge.type === PC_HERO_BADGE_FIRST_PAYMENT_TYPE || policy.isPrePayment;
  const copy = getMembershipPreviewFloatingCtaCopy(new Date(), {
    isFirstPaymentUser,
  });
  const membershipUrl = buildMembershipPreviewFloatingUrl(
    CplatToken || searchParams.get('cplatToken'),
  );

  const handleClick = () => {
    if (window.ReactNativeWebView) {
      postMessage({
        action: 'openExternal',
        data: membershipUrl,
      });
      return;
    }

    window.open(membershipUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-20 bg-gradient-to-b from-wh/0 from-[0%] via-wh via-[50%] to-wh px-[16px] pb-[23px] pt-[50px]">
      {showPreviewNotice && (
        <p className="mb-[8px] whitespace-pre-line text-center text-gr-700 Body5M14">
          {MEMBERSHIP_PREVIEW_FLOATING_NOTICE}
        </p>
      )}
      <button
        type="button"
        aria-label="멤버십 혜택 페이지로 이동"
        className="pointer-events-auto flex h-[74px] w-full items-center gap-[8px] rounded-[10px] bg-gr-50 p-[16px] text-left"
        data-membership-preview-interactive="true"
        onClick={handleClick}
      >
        <IconMembershipFloatingCta aria-hidden className="h-[36px] w-[36px] flex-none" />
        <span className="flex min-w-0 flex-1 flex-col gap-[2px]">
          <span className="truncate text-gr-800 Body3S15">{copy.title}</span>
          <span className="truncate text-gr-600 Caption1M12">{copy.description}</span>
        </span>
      </button>
    </div>
  );
};

export default MembershipPreviewFloatingCTA;
